import { gql } from '@apollo/client'

export default gql(`
query($fileKey: String!) {
    checkS3FileAccess(
        fileKey: $fileKey
    )
}`)
